import { getCookie } from '@calm/web-common/dist/cookies';
import isSSR from '@calm/web-common/dist/isSSR';
import { Environment } from '@rhg/constants';
import useAppConfig from '@rhg/hooks/use-app-config';
import { useEffect, useState } from 'react';

export const E2E_ACCESS_TOKEN = 'e2eAccessToken';
export const E2E_USER_ID = 'e2eUserId';

/**
 * This is a workaround for e2e testing that allows us to circumvent the SSO login
 * screens by setting the access token and userId through cookies.
 *
 * This only works for the Local and Staging environments.
 */
const useE2eAuth = () => {
    const { NEXT_PUBLIC_ENV } = useAppConfig();
    const [accessToken] = useState<string | undefined>(
        !isSSR() ? getCookie(E2E_ACCESS_TOKEN) : undefined
    );
    const [userId] = useState<string | undefined>(
        !isSSR() ? getCookie(E2E_USER_ID) : undefined
    );

    // This is here because the styling gets screwed up if we render as authenticated loaded right away. React needs another cycle
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        setTimeout(() => setIsLoading(false), 0);
    }, []);

    if (
        accessToken &&
        userId &&
        (NEXT_PUBLIC_ENV === Environment.LOCAL ||
            NEXT_PUBLIC_ENV === Environment.STAGING)
    ) {
        const user = {
            sub: userId,
            email: 'test-email@example.com',
        };
        return {
            getAccessTokenSilently: () => Promise.resolve(accessToken),
            getIdTokenClaims: () => Promise.resolve({ __raw: accessToken }),
            isAuthenticated: !isLoading,
            isLoading,
            loginWithRedirect: () => {
                alert(
                    'You are currently using the e2e cookie as an access token. If you would like to test login on staging you will need to clear your cookies'
                );
            },
            logout: () => {
                alert(
                    'You are currently using the e2e cookie as an assess token. If you would like to test logout on staging you will need to clear your cookies'
                );
            },
            user,
            error: null,
        };
    }
};

export default useE2eAuth;
